import React from "react";
import { useNavigate } from "react-router-dom";
import '../../assets/css/style.css';
import HedDan from "./Header";
import BackArow from '../../assets/img/back.svg';
import { useState } from "react";
import { useEffect } from "react";



const ReffralDan = () => {

    const navigate = useNavigate();


    const [refcode, setRefcode] = useState(0);
    const [referrals, setReferrals] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
      const userInfo = JSON.parse(localStorage.getItem("userinfo"));
      if (userInfo && userInfo.ref_code) {
        const code = userInfo.ref_code;
        setRefcode(code);
    
        // دریافت لیست دعوت‌شدگان از سرور
        fetch(`https://app.doneapp.ir/backend/get_referrals.php?ref_code=${code}`)
          .then(response => response.json())
          .then(data => {
            console.log(data); // برای بررسی داده‌های دریافتی
            if (data.status === "success") {
              setReferrals(data.referrals);
            } else {
              console.error(data.message); // پیام خطا را در کنسول نمایش دهید
            }
          })
          .catch(error => console.error("خطا در دریافت لیست دعوت‌شدگان:", error))
          .finally(() => setLoading(false));
      }
    }, []);

  return (
    <>
<HedDan />
    
   <div className="mohtava-mine" >
     
 <section id="reffrals" className="dir-r max-cntt-w v-100">
    <div className="reflist-div-1 mt-30">
      <div className="d-flex">
        <p className="reflist-p-1" onClick={() => navigate("/panel/gifts")}>
          لیست دعوت شدگان شما
        </p>
        <img src={BackArow} className="reflist-img-1" alt="back" onClick={() => navigate("/panel/gifts")} />
      </div>

      {loading ? (
        <p>⏳ در حال دریافت اطلاعات...</p>
      ) : referrals.length > 0 ? (
        referrals.map((user, index) => (
          <div key={user.id} className="reflist-div-2">
            <span className="reflist-span-1">{index + 1}</span>
            <input type="text" className="reflist-input-1" readOnly value={`${user.name} ${user.family}`} />
          </div>
        ))
      ) : (
        <p className="text-center mt-20"> کسی دعوت نشده!</p>
      )}
    </div>
  </section>
 
   </div>
    </>
       
   );
};

export default ReffralDan;
